import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { BrowserModule } from '@angular/platform-browser';
import { TranslateModule } from '@ngx-translate/core';
import { ComumModule } from './../../../shared/comum.module';
import { translateLoaderNBS } from './../../../shared/translate-loader/translateLoader';
import { FuncaoCadastroComponent } from './funcao-cadastro/funcao-cadastro.component';
import { FuncaoFiltroComponent } from './funcao-filtro/funcao-filtro.component';
import { FuncaoListaComponent } from './funcao-lista/funcao-lista.component';
import { FuncaoService } from './funcao-service/funcao.service';
import { FuncaoComponent } from './funcao.component';

@NgModule({
  imports: [
    HttpModule,
    FormsModule,
    CommonModule,
    BrowserModule,
    ReactiveFormsModule,
    ComumModule,
    TranslateModule.forRoot(translateLoaderNBS)
  ],
  exports: [
    FuncaoComponent
  ],
  declarations: [
    FuncaoComponent,
    FuncaoCadastroComponent,
    FuncaoListaComponent,
    FuncaoFiltroComponent
  ],
providers: [
  FuncaoService
]
})
export class FuncaoModule { }
